import {
  Button,
  DialogContent,
  DialogContentText,
  Typography,
} from "@mui/material";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";

import { colors } from "../../../styles/colors";
import fontWeight from "../../../styles/mui/fontWeight";
import { getValue } from "../../../utils";

export interface Props {
  formError: any;
  hasFormError: boolean;
  setHasFormError: (value: boolean) => void;
}
const ErrorDialog = ({ hasFormError, setHasFormError, formError }: Props) => {
  
  return (
    <Dialog
      aria-describedby="alert-dialog-description"
      aria-labelledby="alert-dialog-title"
      disableScrollLock
      onClose={() => setHasFormError(false)}
      open={hasFormError}
    >
      <DialogTitle id="alert-dialog-title">
        <Typography
          color={colors.primary.main}
          fontWeight={fontWeight.Weight[4]}
          variant="h6"
        >
          Please check below details
        </Typography>
      </DialogTitle>
      <DialogContent>
        {formError && typeof formError.errors != "string" && !Object.prototype.hasOwnProperty.call(formError, "title") ? (
          Object.keys(formError).map((field, index) => {
            const messages = formError[field];
            return (
              <DialogContentText
                id="alert-dialog-description"
                key={field}
                mb={"0.5rem"}
              >
                <Typography
                  color={colors.black[2]}
                  fontWeight={fontWeight.Weight[4]}
                  variant="body1"
                >
                  {index + 1}. {messages[0]}
                </Typography>
              </DialogContentText>
            );
          })
        ) : (
          <DialogContentText id="alert-dialog-description" mb={"0.5rem"}>
            {!Object.prototype.hasOwnProperty.call(formError, "title") ? (
              <Typography
                color={colors.black[2]}
                fontWeight={fontWeight.Weight[4]}
                variant="body1"
              >
                {formError}
              </Typography>
            ) : (
              <Typography
                color={colors.black[2]}
                fontWeight={fontWeight.Weight[4]}
                variant="body1"
              >
                {getValue(formError, "title")}
              </Typography>
            )}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button variant="outlined" onClick={() => setHasFormError(false)}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
